module.exports = __webpack_public_path__ + "static/img/icon-enter-item8.0ff0776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item8.png
// module id = gN0m
// module chunks = 21